var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "modal fade",
      attrs: {
        id: "modal-delete-" + _vm.idKey,
        tabindex: "-1",
        role: "dialog",
        "aria-labelledby": "modal-delete-" + _vm.idKey,
        "aria-hidden": "true",
      },
    },
    [
      _c("div", { staticClass: "modal-dialog" }, [
        _c("div", { staticClass: "modal-content" }, [
          _vm._m(0),
          _vm._v(" "),
          _vm._m(1),
          _vm._v(" "),
          _c("div", { staticClass: "modal-footer" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-danger btn-large pull-left",
                attrs: {
                  "data-toggle": "modal",
                  "data-target": "#modal-delete-" + _vm.idKey,
                },
              },
              [_vm._v("Cancel")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn-primary btn-large",
                attrs: {
                  "data-toggle": "modal",
                  "data-target": "#modal-delete-" + _vm.idKey,
                },
                on: {
                  click: function ($event) {
                    return _vm.$emit("deletePhoto")
                  },
                },
              },
              [_vm._v("Delete")]
            ),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "modal-header text-center danger" }, [
      _c("h4", [_vm._v("Confirmation")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "modal-body" }, [
      _c("p", [
        _vm._v(
          "This action will permanently remove the photo from our database!"
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }